module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Sorcerers-Apprentice-The.830cf67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Sorcerers-Apprentice-The.jpg
// module id = 8Rew
// module chunks = 0